import React, { useEffect, useState } from "react";
import axios from "axios";

const ProductRules = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // form fields
  const [areaCode, setAreaCode] = useState("");
  const [productCap, setProductCap] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [noOfProduct, setNoOfProduct] = useState("");

  // rule selections
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCardTypes, setSelectedCardTypes] = useState([]);
  const [selectedProductGroup, setSelectedProductGroup] = useState([]);
  const [selectedNewGroup, setSelectedNewGroup] = useState([]);

  const [rulesExist, setRulesExist] = useState(false);

  const statesList = [
    "AK","AL","AR","AZ","CA","CO","CT","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA",
    "MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK",
    "OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY"
  ];

  const cardTypes = ["Visa", "Master Card", "American Express", "Discover"];

  // Fetch all products on load
  useEffect(() => {
    axios.get("https://crm-server-htk6.vercel.app/api/products")
      .then(res => setProducts(res.data))
      .catch(err => console.error("❌ Error fetching products:", err));
  }, []);

  // When product changes, fetch its rules
  useEffect(() => {
    if (!selectedProduct) return;

    axios.get(`https://crm-server-htk6.vercel.app/api/productRules/${selectedProduct._id}`)
      .then(res => {
        if (res.data && res.data._id) {
          setRulesExist(true);
          setAreaCode(res.data.areaCode || "");
          setProductCap(res.data.productCap || "");
          setIsActive(res.data.isActive ?? true);
          setNoOfProduct(res.data.noOfProduct || "");
          setSelectedStates(res.data.states || []);
          setSelectedCardTypes(res.data.cardTypes || []);
          setSelectedProductGroup(res.data.productGroup || []);
          setSelectedNewGroup(res.data.newGroup || []);
        } else {
          // reset if no rules exist
          setRulesExist(false);
          setAreaCode("");
          setProductCap("");
          setIsActive(true);
          setNoOfProduct("");
          setSelectedStates([]);
          setSelectedCardTypes([]);
          setSelectedProductGroup([]);
          setSelectedNewGroup([]);
        }
      })
      .catch(err => console.error("❌ Error fetching product rules:", err));
  }, [selectedProduct]);

  const toggleSelection = (list, setList, value) => {
    if (list.includes(value)) {
      setList(list.filter(v => v !== value));
    } else {
      setList([...list, value]);
    }
  };
const handleSave = async () => {
  if (!selectedProduct) {
    alert("⚠️ Please select a product first");
    return;
  }

  // ✅ Check if at least ONE rule is selected
  const noRulesSelected =
    selectedStates.length === 0 &&
    selectedCardTypes.length === 0 &&
    selectedProductGroup.length === 0 &&
    selectedNewGroup.length === 0;

  if (noRulesSelected) {
    alert("⚠️ Please select at least one rule (State, Card Type, Product Group, or New Group).");
    return;
  }

  const payload = {
    areaCode,
    productCap,
    isActive,
    noOfProduct,
    states: selectedStates,
    cardTypes: selectedCardTypes,
    productGroup: selectedProductGroup,
    newGroup: selectedNewGroup,
  };

  try {
    if (rulesExist) {
      // ✅ Update existing rules
      await axios.put(
        `https://crm-server-htk6.vercel.app/api/productRules/${selectedProduct._id}`,
        payload
      );
      alert("✅ Product rules updated successfully");
    } else {
      // ✅ Create new rules
      await axios.post("https://crm-server-htk6.vercel.app/api/productRules", {
        productId: selectedProduct._id,
        ...payload,
      });
      alert("✅ Product rules created successfully");
    }
  } catch (err) {
    console.error("❌ Error saving product rules:", err);
    alert("⚠️ Failed to save product rules");
  }
};


  return (
    <div className="page">
      <h2>Product Rules</h2>

      {/* Top Form */}
      <div className="form-container">
        <div className="form-row">
          <select
            value={selectedProduct ? selectedProduct._id : ""}
            onChange={(e) => {
              const prod = products.find(p => p._id === e.target.value);
              setSelectedProduct(prod || null);
            }}
          >
            <option value="">Select Product</option>
            {products.map(p => (
              <option key={p._id} value={p._id}>{p.productName}</option>
            ))}
          </select>

          <input
            type="text"
            placeholder="Area Code"
            value={areaCode}
            onChange={(e) => setAreaCode(e.target.value)}
          />
          <input
            type="text"
            placeholder="Product Cap"
            value={productCap}
            onChange={(e) => setProductCap(e.target.value)}
          />
          <select
            value={isActive}
            onChange={(e) => setIsActive(e.target.value === "true")}
          >
            <option value="true">Active - True</option>
            <option value="false">Active - False</option>
          </select>
          <input
            type="number"
            placeholder="No. of Product"
            value={noOfProduct}
            onChange={(e) => setNoOfProduct(e.target.value)}
          />
        </div>

        <button className="save-btn" onClick={handleSave}>
          {rulesExist ? "Update" : "Save"}
        </button>
      </div>

      {/* Blocks */}
    {/* Rules Containers */}
<div className="rules-container">
  {/* 1. State Wise */}
  <div className="rules-block">
    <h3>State Wise Product Block</h3>
    <div className="checkbox-group">
      {statesList.map((s) => (
        <label key={s}>
          <input
            type="checkbox"
            checked={selectedStates.includes(s)}
            onChange={() =>
              toggleSelection(selectedStates, setSelectedStates, s)
            }
          />
          {s}
        </label>
      ))}
    </div>
  </div>

  {/* 2. Card Types */}
  <div className="rules-block">
    <h3>Card Type Wise Product Block</h3>
    <div className="checkbox-group">
      {cardTypes.map((c) => (
        <label key={c}>
          <input
            type="checkbox"
            checked={selectedCardTypes.includes(c)}
            onChange={() =>
              toggleSelection(selectedCardTypes, setSelectedCardTypes, c)
            }
          />
          {c}
        </label>
      ))}
    </div>
  </div>

  {/* 3. Product Group */}
  <div className="rules-block">
    <h3>Product Group Block</h3>
    <div className="checkbox-group">
      {products.map((p) => (
        <label key={p._id}>
          <input
            type="checkbox"
            checked={selectedProductGroup.includes(p.productName)}
            onChange={() =>
              toggleSelection(
                selectedProductGroup,
                setSelectedProductGroup,
                p.productName
              )
            }
          />
          {p.productName}
        </label>
      ))}
    </div>
  </div>

  {/* 4. New Group */}
  <div className="rules-block">
    <h3>Similar Products</h3>
    <div className="checkbox-group">
      {products.map((p) => (
        <label key={p._id}>
          <input
            type="checkbox"
            checked={selectedNewGroup.includes(p.productName)}
            onChange={() =>
              toggleSelection(
                selectedNewGroup,
                setSelectedNewGroup,
                p.productName
              )
            }
          />
          {p.productName}
        </label>
      ))}
    </div>
  </div>
</div>

    </div>
  );
};

export default ProductRules;
